import { useState } from 'react'

import { F0Button, F0Card } from '@factorialco/f0-react'
import { OneModal } from '@factorialco/f0-react/dist/experimental'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import rewardImage1 from 'modules/referral_program/lib/assets/reward1.png'
import rewardImage2 from 'modules/referral_program/lib/assets/reward2.png'
import rewardImage3 from 'modules/referral_program/lib/assets/reward3.png'

interface ChooseRewardModalProps {
  open: boolean
  onClose: () => void
  rewardSelected: string | null
  setRewardSelected: (reward: string | null) => void
  setLinkGenerated: (linkGenerated: boolean) => void
}

const ChooseRewardModal: React.FC<ChooseRewardModalProps> = ({
  open,
  onClose,
  rewardSelected,
  setRewardSelected,
  setLinkGenerated,
}) => {
  const [loading, setLoading] = useState(false)

  const handleGenerateLink = () => {
    setTimeout(() => {
      track(trackingEvents.settings.clickGenerateReferralProgramLink, {
        reward_selected: rewardSelected,
      })
      setLinkGenerated(true)
      setLoading(false)

      handleClose()
    }, 2000)
    setLoading(true)
  }

  const handleClose = () => {
    onClose()
  }

  const rewards = [
    {
      id: 'price_1',
      image: rewardImage1,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.description'
      ),
    },
    {
      id: 'price_2',
      image: rewardImage2,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.description'
      ),
    },
    {
      id: 'price_3',
      image: rewardImage3,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.description'
      ),
    },
  ]
  return (
    <OneModal isOpen={open} onClose={onClose}>
      <OneModal.Header
        title={i18n.t(
          'company_settings.general.factorial_referral_program.revamp.reward_modal.title'
        )}
      />
      <OneModal.Content withPadding>
        <div className="flex flex-col gap-4">
          <div className=" text-f1-foreground-secondary">
            {i18n.t(
              'company_settings.general.factorial_referral_program.revamp.reward_modal.description'
            )}
          </div>
          <div className="flex flex-row gap-2 justify-center">
            {rewards.map((reward) => (
              <F0Card
                key={reward.title}
                image={reward.image}
                title={reward.title}
                description={reward.description}
                onSelect={() => {
                  setRewardSelected(reward.id)
                }}
                selectable
                selected={rewardSelected === reward.id}
                onClick={() => {
                  setRewardSelected(reward.id)
                }}
              />
            ))}
          </div>
        </div>
      </OneModal.Content>
      <OneModal.Footer>
        <div className="flex flex-row gap-2 justify-end w-full">
          <F0Button
            size="lg"
            onClick={onClose}
            label={i18n.t(
              'company_settings.general.factorial_referral_program.revamp.reward_modal.button.close'
            )}
            variant="outline"
          />
          <F0Button
            size="lg"
            onClick={handleGenerateLink}
            label={
              loading
                ? i18n.t(
                    'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generating_link'
                  )
                : i18n.t(
                    'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generate_link'
                  )
            }
            disabled={!rewardSelected || loading}
          />
        </div>
      </OneModal.Footer>
    </OneModal>
  )
}

export default ChooseRewardModal
